import React, { useContext, useState, useRef } from 'react';
import './Navbar.css';
import logo from '../Assets/logo.png';
import cart_icon from '../Assets/cart.png';
import { Link } from 'react-router-dom';  // Fixed import
import { ShopContext } from '../../Context/ShopContext';
import open_menu from '../Assets/open-menu.png';

export const Navbar = () => {
  const [menu, setMenu] = useState('Livestock');
  const { getTotalCartItems } = useContext(ShopContext) || {};  // Added fallback
  const menuRef = useRef();

  const dropdown_toggle = (e) => {
    menuRef.current.classList.toggle('nav-menu-visible');
    e.target.classList.toggle('open');
  };

  return (
    <div className='navbar'>
      <div className="nav-logo">
        <img src={logo} alt='ETOLEE-Logo'/>    
      </div>
      <img className='nav-dropdown' onClick={dropdown_toggle} src={open_menu} alt="" />
      <ul ref={menuRef} className="nav-menu">
        <li onClick={() => setMenu("Livestock")}>
          <Link style={{textDecoration: 'none', color: 'black'}} to='/'>Livestock</Link>
          {menu === "Livestock" ? <hr/> : null}
        </li>
        <li onClick={() => setMenu("Cows")}>
          <Link style={{textDecoration: 'none', color: 'black'}} to='/Cows'>Cows</Link>
          {menu === "Cows" ? <hr/> : null}
        </li>
        <li onClick={() => setMenu("Goats")}>
          <Link style={{textDecoration: 'none', color: 'black'}} to='/Goats'>Goats</Link>
          {menu === "Goats" ? <hr/> : null}
        </li>
        <li onClick={() => setMenu("Camels")}>
          <Link style={{textDecoration: 'none', color: 'black'}} to='/Camels'>Camel</Link>
          {menu === "Camels" ? <hr/> : null}
        </li>
        <li onClick={() => setMenu("Sheeps")}>
          <Link style={{textDecoration: 'none', color: 'black'}} to='/Sheeps'>Sheep</Link>
          {menu === "Sheeps" ? <hr/> : null}
        </li>
      </ul>
      <div className="nav-login-cart">
        {localStorage.getItem('auth-token') 
          ? (
            <button onClick={() => {
              localStorage.removeItem('auth-token');
              window.location.replace('/');
            }}>
              Log Out
            </button>
          ) 
          : (
            <Link to='/login'>
              <button>Log In</button>
            </Link>
          )
        }
        <Link to='/cart'><img src={cart_icon} alt=''/></Link>
        <div className="cart-count">
          {getTotalCartItems ? getTotalCartItems() : 0}
        </div>
      </div>
    </div>
  );
};

export default Navbar;